export default __webpack_public_path__ + "static/media/CartIcon.7b877d0e.svg";